import { FC } from 'react';
import { CircularProgress } from '@material-ui/core';

import styles from './AvailabilityProgress.module.scss';

interface IAvailabilityProgressProps {
  message: string;

    detail?: string;
}

const AvailabilityProgress: FC<IAvailabilityProgressProps> = ({
  message,
  detail,
}) => (
  <div className={styles['container']}>
    <CircularProgress className={styles['progress']} size={40} />

    <span className={styles['message']}>{message}</span>

    {detail && <span className={styles['detail']}>{detail}</span>}
  </div>
);

export default AvailabilityProgress;
